const Header = {
  init() {
    Header.events();
    Header.toggle();
    Header.sub_menu();
    Header.search();
    Header.mobile();

    $(window).on("resize", function () {
      Header.mobile();
    });
  },

  events() {
    Header.scroll();
    $(window).scroll(function () {
      Header.scroll();
    });
  },

  mobile() {
    if ($(window).width() <= 1250) {
      var height = $("html").offset().top;
      var totalHeight = height + $(".header").height();

      // QCF overlay
      $(".header .qcf").css("top", height);

      // Menu
      $(".header__right").css({
        height: "calc(100vh - " + totalHeight + "px)",
      });
    } else {
      $(".header .qcf").css("top", "");
      $(".header__right").css("height", "");
    }
  },

  toggle() {
    var windowScrollTop = $(window).scrollTop();
    // toggle main navigation mobile
    $(".toggle-menu").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("active");
      $(".header").toggleClass(
        "header--was-scrolled",
        $(".header").hasClass("header--scrolled")
      );
      if (!$(".header").hasClass("header--mobile-open"))
        windowScrollTop = $(window).scrollTop();
      $(".header").toggleClass("header--mobile-open");
      $("html").toggleClass("no-scroll");
      $("html, body").scrollTop(windowScrollTop);

      if (!$(".header-menu").attr("style")) {
        var el = $(
          '<div style="position: fixed; height: 100vh;"></div>'
        ).appendTo("body");
        var vh100 = el.height();
        el.remove();
        $(".header-menu").css({
          borderBottomWidth: vh100 - $(window).outerHeight(),
        });
      }
    });

    // Toggle dropdown
    $(".lang-item--current").on("click", function (e) {
      e.preventDefault();
      var btn = $(this);
      $('.lang-switcher__list').toggleClass('open');
    });
  },

  sub_menu() {
    // Submenu functionality
    $(".menu-item__toggle-submenu").on("click", function (e) {
      e.preventDefault();
      var btn = $(this);
      var menuItem = btn.closest(".menu-item");
      var siblings = menuItem.siblings();

      menuItem.toggleClass("menu-item--submenu-open");
      menuItem.find(".sub-menu").slideToggle(250);

      siblings.children(".sub-menu").slideUp(250);
      siblings.removeClass("menu-item--submenu-open");

      if ($(".menu-item--submenu-open").length) {
        $("html").addClass("no-scroll");
      } else {
        $("html").addClass("no-scroll");
      }
    });
  },

  search() {
    $(".search-toggle").click(function (e) {
      if (!$(".header-search.active").length) {
        e.preventDefault();
        $(".header-search").addClass("active");
        $(".header-search__input").focus();
      }
    });

    $(".header-search__input").blur(function () {
      $(".header-search").removeClass("active");
    });

    $(".header-search").submit(function (e) {
      if (!$("#search").val()) e.preventDefault();
    });

    $(".search-box__form").submit(function (e) {
      if (!$("#s").val()) e.preventDefault();
    });
  },

  scroll() {
    var st = $(window).scrollTop();
    if (st > 110) {
      $(".header").addClass("header--scrolled");
    } else {
      $(".header").removeClass("header--scrolled");
    }
  },
};
export default Header;
